/**
 * Copyright ©2023 Drivepoint
 */

import React, {ReactNode} from "react";
import CloseIcon from "@mui/icons-material/Close";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@mui/material";
import {Breakpoint} from "@mui/system";
import DPDivider from "../DPDivider/DPDivider";
import "./DPDialog.css";

type DPDialogProps = {
  isOpen: boolean;
  hideHeaderDivider?: boolean;
  hideFooterDivider?: boolean;
  hideCloseButton?: boolean;
  title?: string | ReactNode;
  handleClose?: () => void;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
  fullWidth?: boolean;
  maxWidth?: Breakpoint | false;
};

export default function DPDialog(props: DPDialogProps) {

  return <Dialog
    open={props.isOpen}
    className={`dp-dialog-container ${props.className ?? ""}`}
    onClose={props.handleClose}
    fullWidth={props.fullWidth}
    maxWidth={props.maxWidth}
  >
    {(!props.hideCloseButton || props.title) && <DialogTitle className="dp-dialog-header">
      <div className="dp-dialog-header-title">{props.title}</div>
      <div className="dp-dialog-header-toolbar">
        {!props.hideCloseButton && <IconButton onClick={props.handleClose} sx={{color: "rgba(51, 51, 51, 0.56)"}}>
          <CloseIcon />
        </IconButton>}
      </div>
    </DialogTitle>}
    {!props.hideHeaderDivider && <DPDivider type="horizontal" />}
    <DialogContent>{props.children}</DialogContent>
    {props.actions && !props.hideFooterDivider && <DPDivider type="horizontal" />}
    {props.actions && <DialogActions className="dp-dialog-actions">{props.actions}</DialogActions>}
  </Dialog>;
}
